<template>
    <div>
       <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Order Custom Fields</template>
        </page-header>

        <div class="px-6 pt-2">
            <div class="flex justify-start mt-2 flex-wrap">
                <div class="relative pr-4 mb-3 w-1/4">
                    <input-select class="sm:col-span-4"
                        label="Group"
                        placeholder="Select Group"
                        name="selectedGroup"
                        v-model="selectedType"
                        return="value"
                        :options="options.types"
                        @input="onSelectType"/>
                </div>
            </div>
        </div>

        <div class="px-6 pt-2" v-if="selectedType">
            <div class="flex justify-start mt-2 flex-wrap">
                <div class="relative pr-4 mb-3 w-full">
                    <label class="block w-full text-sm pb-1">Custom Fields
                        <span><font-awesome-icon class="text-sm text-sm ml-2" style="top: 12px; cursor: pointer;" tooltip="Sort By Name" :icon="['fas', 'sort-up']" v-on:click="onAscending" /></span>
                        <span><font-awesome-icon class="text-sm text-sm ml-2" style="top: 12px; cursor: pointer;" tooltip="Reset" :icon="['fas', 'undo']" v-on:click="onReset" /></span>
                    </label>
                    <ul class="list-group list-reset">
                        <draggable :list="selectedFields">
                            <li v-for="(field, index) in selectedFields" v-bind:key="index" class="cursor-move border border-gray-500 py-1 px-2 mb-2 bg-gray-200 text-sm" draggable="true" v-on:dragstart="dragstart(field, $event)" v-on:dragend="dragend($event)">
                                <div class="relative pr-4 mb-3 inline">{{ field.label }}</div><div class="relative pr-4 mb-3 float-right">({{ field.ordering ? field.ordering : 'N/A' }})</div>
                                <!-- {{ type.name }} -->
                            </li>
                        </draggable>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import draggable from 'vuedraggable';

    export default {
        name: 'TypeOrdering',
        components: {
            draggable
        },
        data: function(){
            return {
                pageActions: {
                    buttons: [
                        {
                            label: 'Cancel',
                            icon: 'times',
                            iconClass: 'text-red-600',
                            type: 'method',
                            method: 'cancel'
                        },
                        {
                            label: 'Apply',
                            icon: 'check',
                            iconClass: 'text-green-600',
                            type: 'method',
                            method: 'apply'
                        }
                    ]
                },
                options: {
                    fields: [],
                    types: []
                },
                selectedType: null,
                selectedFields: [],
                dragging: false

            }
        },
        beforeMount() {
            this.getData();
        },
        mounted() {
            this.$Progress.finish();
        },
        methods: {
            // Get groups and types
            getData: function(){
                axios.get(process.env.VUE_APP_API_URL + '/types', {
                    params: {
                        filters: { group: {name: 'group', value: 'custom-field-models' }},
                        sortColumn: 'name',
                        sortDir: 'ASC'
                    }
                }).then(response => {
                    this.options.types = response.data.map(function (group) {
                        return { label: group.name, value: group.name };
                    });
                });

                axios.get(process.env.VUE_APP_API_URL + '/custom-fields', {
                    params: {
                        sortColumn: 'ordering',
                        sortDir: 'ASC'
                    }
                })
                .then(response => {
                    // Fields
                    this.options.fields = response.data.map(function (field) {
                        return { id: field.id, label: field.label, model: field.model, ordering: field.ordering };
                    });
                });
            },
            methodHandler: function(method){
                this[method]();
            },
            dragstart: function(item, e) {
                this.$emit('redrag', item);
                e.target.style.opacity = 0.5;
                // e.dataTransfer.setData('text/plain', 'type');
            },
            dragend: function(e) {
                e.target.style.opacity = 1;
                this.setOrder();
            },
            onSelectType: function(){
                console.log(this.options.fields);
                console.log(this.selectedType);
                if (this.selectedType){
                    this.selectedFields = this.options.fields.filter(t => t.model === this.selectedType);
                    // this.setOrder();
                } else {
                    this.selectedFields = [];
                    return null;
                }
            },
            onAscending: function() {
                this.selectedFields.sort(function (a, b) {
                    if (a.label < b.label) return -1;
                    if (b.label < a.label) return 1;
                    return 0;
                });

                this.setOrder();
            },
            onReset: function(){
                this.selectedFields = this.options.fields.filter(t => t.model === this.selectedType);
                this.setOrder();
            },
            setOrder: function(){
                // set the ordering on the elements
                this.selectedFields.forEach((t, index) => {
                    t.ordering = (index + 1);
                });
            },
            cancel: function(){
                this.$router.push('/configuration/custom-fields');
            },
            apply: function(){

                // set backdrop
                this.$store.commit('TOGGLE_BACKDROP', { open: true });

                if(this.selectedFields.some(t => t.ordering === '')){
                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'error',
                        title: 'Warning',
                        text: 'Object has no order',
                        duration: 5000
                    });

                    this.$store.commit('TOGGLE_BACKDROP', { open: false });
                    return;
                }


                axios.post(process.env.VUE_APP_API_URL + '/ordering', {
                    orderingType: 'custom-fields',
                    orderingData: this.selectedFields
                }).then(response => {
                    this.$store.commit('TOGGLE_BACKDROP', { open: false });

                    if (response.data.success){
                        this.$notify({
                            group: 'main',
                            position: 'bottom right',
                            type: 'success',
                            title: 'Success',
                            text: response.data.message,
                            duration: 5000
                        });
                    }

                }).catch(() => {
                    this.$store.commit('TOGGLE_BACKDROP', { open: false });
                });
            }

        },
        computed: {
            // groupValue: function(){
            //     if (this.selectedGroup){
            //         this.selectedTypes = this.options.types.filter(t => t.group == this.selectedGroup);
            //         // this.setOrder();
            //         return {label: '', value: this.selectedGroup  };
            //     } else {
            //         this.selectedTypes = [];
            //         return null;
            //     }
            // },
            // selectedTypes: function(){
            //     console.log('selectedTypes');
            //     if (this.selectedGroup){
            //        return this.options.types.filter(t => t.group == this.selectedGroup);
            //     } else {
            //         return [];
            //     }
            // },

        }
    }
</script>
